// Facility brand colour (appTheme.themeColor) → CSS vars --theme/-deep/-dark/
// -accent/-soft. applyThemeColor sets them on :root globally; themeVars returns
// the same map for inline use. Derivation mirrors the ai-service PDF theme.

const _hex6 = (h) =>
  /^#?[0-9a-fA-F]{6}$/.test(h || "") ? (h[0] === "#" ? h.slice(1) : h) : null;

const _mix = (hex, amt, toWhite) => {
  const h = _hex6(hex);
  if (!h) return hex;
  const ch = (i) => {
    const c = parseInt(h.slice(i, i + 2), 16);
    const v = toWhite ? Math.round(c + (255 - c) * amt) : Math.round(c * (1 - amt));
    return v.toString(16).padStart(2, "0");
  };
  return `#${ch(0)}${ch(2)}${ch(4)}`;
};

export const normaliseBrand = (raw) => {
  if (!raw) return "";
  const hex = raw.replace("0x", "#");
  return _hex6(hex) ? (hex[0] === "#" ? hex : `#${hex}`) : "";
};

export const themeVars = (brand) => {
  const hex = normaliseBrand(brand);
  if (!hex) return {};
  return {
    "--theme": hex,
    "--theme-deep": _mix(hex, 0.55, false),
    "--theme-dark": _mix(hex, 0.3, false),
    "--theme-accent": _mix(hex, 0.3, true),
    "--theme-soft": _mix(hex, 0.88, true),
  };
};

export const applyThemeColor = (brand) => {
  if (typeof document === "undefined") return;
  const vars = themeVars(brand);
  const root = document.documentElement;
  if (!Object.keys(vars).length) return;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
};
